import Fuse from "fuse.js";
import { useMemo } from "react";
import { NominatimResult } from "./useNominatimGeocoding";

export function useFuzzyNominatimResults(
  results: NominatimResult[],
  query: string,
) {
  return useMemo(() => {
    if (!query || results.length === 0) return results;

    const fuse = new Fuse(results, {
      keys: [
        { name: "name", weight: 0.6 },
        { name: "display_name", weight: 0.4 },
      ],
      threshold: 0.4,
      ignoreLocation: true,
    });

    return fuse.search(query).map((r) => r.item);
  }, [results, query]);
}
